import { Lock } from "lucide-react";
import { Reveal } from "./Reveal";
import { useLang } from "../config/i18n";

export const Sigilo = () => {
  const { t } = useLang();

  return (
    <section data-testid="privacy-section" className="relative py-24 sm:py-32">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <Reveal>
          <span className="inline-flex w-16 h-16 rounded-full border border-[#C5A059]/40 items-center justify-center mb-8">
            <Lock size={24} className="text-[#C5A059]" strokeWidth={1.4} />
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl text-[#F7F7F8] leading-snug mb-8">{t.sigilo.title}</h2>
          <div className="space-y-5 text-[15px] sm:text-base text-[#A3A3AF] leading-relaxed font-light">
            {t.sigilo.paragraphs.map((p) => (
              <p key={p.slice(0, 24)}>{p}</p>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
